<template>
  <li class="text-xs">
    <strong v-text="fieldLabel" />: <span v-html="fieldValue" />
  </li>
</template>

<script type="text/babel">
import { mapState } from 'vuex'

export default {
  name: 'FormFieldValue',
  props: {
    field: {
      type: Object,
      required: true,
    },
    fieldLabel: {
      type: String,
      required: true,
    },
    value: {
      required: true,
      validator: prop => typeof prop === 'string' || prop === null,
    },
  },
  computed: {
    ...mapState({
      form: state => state.form.form,
    }),
    fieldValue() {
      switch (this.field.attributes.input_type) {
        case 'form-file':
        case 'form-image':
          return `<a href="${this.documentUrl}" target="_blank" rel="noopener noreferrer">View Form Assets</a>`
        case 'form-date':
        case 'form-datetime-local':
          return this.value ? this.$date.toMomentDateFormat(this.value) : '--'
        default:
          return this.value || '--'
      }
    },
    documentUrl() {
      return this.$urlGenerator.active(`documents/folders/${this.form.folder.uuid}`)
    },
  },
}
</script>
